<template>
    <div class="rsv_item" ref="rsvCell" :class="{'selected': isSelectedReservation, 'same': isSameHService}"
        :style="locationStyleString"
        @click.left="action_Click"
        @click.right="action_RightClick"
        @dblclick="action_DoubleClick"
        @dbclick="action_DoubleClick"
        @mouseover="action_ReservationMouseOver($event)"
        @mouseout="action_ReservationMouseOut($event)"
    >
        <div class="rsv_item_box">
            <span class="join_badge lblue" v-if="isJoined">{{ $t('reservationwindow.reservationmonitor.label_register') }}</span>

            <div class="name_box">
                <span class="ad_ic" v-if="isAfterDoc">
                    <img src="../../../../../../../assets/img/ic_afterdoc_symbol_saas.png" alt="">
                </span>
                <AILogo v-if="reservation.writerType === 2900" />
                <span class="name" :style="textAutoStyle">{{ userName }}</span>
                <span class="chartnum" v-if="isUsingChartNumber && checkReservationDataIncluded('chartNumber')"
                    :style="textAutoStyle"> ({{ chartNumber }})</span>
            </div>
            <span class="gen" v-if="checkReservationDataIncluded('gender')"
                :style="textAutoStyle">{{ gender }}</span>

            <span class="birth" v-if="checkReservationDataIncluded('birth')"
                :style="textAutoStyle">{{ birth }}</span>

            <span class="patient_type" v-if="isUsingFirstVisitStartDate && checkReservationDataIncluded('isFirstVisit')"
                :style="textAutoStyle">{{ isFirstVisit }}</span>

            <span class="user_tag" v-if="isUsingUserTag && checkReservationDataIncluded('userTagIDs')"
                :style="textAutoStyle">{{ tags }}</span>
            <span class="program" v-if="checkReservationDataIncluded('programID')"
                :style="textAutoStyle">{{ programName }}</span>

            <span class="rsv_memo" v-if="checkReservationDataIncluded('note')"
                :style="textAutoStyle">{{ reservationMemo }}</span>

            <span class="patient_memo" v-if="checkReservationDataIncluded('reservationUserNote')"
                :style="textAutoStyle">{{ treatmentMemo }}</span>
        </div>
    </div>
</template>


<script>
import { deepCopy } from '@/util/deep-copy'
import { formatGenderShort } from '@/util/format-gender'
import { toBirth6String } from '@/util/format-birth'
import { typeToString } from '@/util/type-to-string'
import { sheetState } from '../../../sheet-state'
import { closeHServiceSearch, hideCellMenu, hideColumnMenu, hideGroupMenu, sheetOverlays, showReservationInfoPopup, showReservationMenu } from '../../../sheet-overlays'
import { reservationSelection, setSelectedReservation } from '../../../reservation-selection'
import { sheetAxis } from '../../../sheet-axis'
import AILogo from '../../../../ShareComponents/AILogo/AILogo.vue'

export default {
    components: {
        AILogo
    },
    props: {
        maxDepth: Number,
        reservation: Object,
        hoverReservation: Object,
        selectedAreaHelper: Object
    },
    data() {
        return {
            sheetState,
            sheetOverlays,
            reservationSelection,
            sheetAxis,

            hoverEvent: {
                x: 0,
                y: 0
            }
        }
    },
    watch: {
        isSelectedReservation: {
            immediate: true,
            deep: true,
            handler: function (newValue) {
                if (newValue == true) {
                    this.updateElement()
                }
            }
        }
    },
    computed: {
        isAfterDoc: function () {
            if (this.reservation.writerType >= 3000 || this.reservation.writerType <= 1000) {
                return true
            }
            return false
        },
        isUsingChartNumber: function () {
            return this.servicesetting?.setting?.usingChartNumber ?? false
        },
        isUsingFirstVisitStartDate: function () {
            return this.servicesetting?.setting?.usingFirstVisitStartDate ?? false
        },
        isUsingUserTag: function () {
            return this.servicesetting?.setting?.usingUserTag ?? false
        },
        hservice: function () {
            return this.reservation.hserviceID
        },
        userName: function () {
            const hserviceName = this.reservation?.hserviceID?.name
            return hserviceName ?? this.reservation?.userName
        },
        chartNumber: function () {
            return this.hservice?.chartNumber ?? ''
        },
        gender: function () {
            return formatGenderShort(this.hservice?.gender) ?? '-'
        },
        birth: function () {
            return toBirth6String(this.hservice?.birth) ?? '-'
        },
        isFirstVisit: function () {
            if (this.hservice.isFirstVisit == undefined) {
                return ''
            }
            return this.hservice.isFirstVisit == true ? '초진' : '재진'
        },
        tags: function () {
            let returnValue = ''
            for (let i = 0; i < this.hservice.userTagIDs.length; i++) {
                if (!this.hservice.userTagIDs[i]?.name) {
                    continue
                }
                if (returnValue != '') {
                    returnValue += ', '
                }
                returnValue += this.hservice.userTagIDs[i].name
            }
            if (returnValue.length == 0) {
                return ''
            }
            return `${ returnValue }`
        },
        programName: function () {
            return this.reservation?.programTitle
        },
        reservationMemo: function () {
            return this.reservation?.note
        },
        treatmentMemo: function () {
            const note = this.sheetState.reservationUserNotes?.find((note) => {
                return note.hserviceID == this.hservice._id
            })
            return note?.content ?? ''
        },
        status: function () {
            return this.reservation?.statusID
        },
        setting: function () {
            return this.sheetState.reservationSetting
        },
        palette: function () {
            return this.setting?.statusColorPaletteID?.basicPalette ?? []
        },
        timeInterval: function () {
            return this.sheetAxis.selectedTimeInterval
        },
        timeArray: function () {
            return this.sheetAxis.timeArray
        },
        locationStyleString() {
            return `${ this.getCalcBgColorValueForCSS() } ${ this.getCalcLeftValueForCSS() } ${ this.getCalcWidthValueForCSS() } ${ this.getCalcTopAndHeightValueForCSS() }`
        },
        textAutoStyle: function () {
            let bgColorString = this.palette?.[this.reservation?.statusID?.paletteIndex]

            let hex = '#222222'

            let r = parseInt(bgColorString.substr(1, 2), 16)
            let g = parseInt(bgColorString.substr(3, 2), 16)
            let b = parseInt(bgColorString.substr(5, 2), 16)

            let l = (0.2126 * r) + (0.7152 * g) + (0.0722 * b);

            if (l <= 150) {
                hex = '#FFFFFF'
            }
            return 'color:' + hex + ';'
        },


        selectedReservation: function () {
            return this.reservationSelection.selectedReservation
        },
        selectedHServiceID: function () {
            let hserviceID = this.selectedReservation?.hserviceID
            if (typeToString(hserviceID) == 'object') {
                hserviceID = hserviceID?._id
            }
            return hserviceID
        },
        hserviceID: function () {
            let hserviceID = this.reservation?.hserviceID
            if (typeToString(hserviceID) == 'object') {
                hserviceID = hserviceID._id
            }
            return hserviceID
        },
        isSelectedReservation: function () {
            if (this.reservationSelection.selectedReservation == undefined) {
                return false
            }
            return this.reservation._id == this.reservationSelection.selectedReservation._id
        },
        isSameHService: function () {
            if (this.isSelectedReservation == true) {
                return false
            }
            return this.hserviceID == this.selectedHServiceID
        },
        closeReason: function() {
            return this.hservice?.closeReason ?? []
        },
        isClosed: function() {
            return this.closeReason.length > 0
        },
        isJoined: function() {
            return this.hservice?.lastLogin != undefined && this.isClosed == false
        }
    },
    methods: {
        // MARK: - Actions
        action_Click() {
            if (this.reservationSelection.isTimeSelectMode == true) {
                return
            }
            setSelectedReservation(this.reservation)
        },
        action_DoubleClick() {
            if (this.reservationSelection.isTimeSelectMode == true) {
                return
            }
            setSelectedReservation(deepCopy(this.reservation))
            this.reservationSelection.selectedHService = deepCopy(this.reservation.hserviceID)
            showReservationInfoPopup()
        },
        action_RightClick(e) {
            if (this.sheetOverlays.isShowHServiceSearch) {
                closeHServiceSearch()
            }
            if (this.sheetOverlays.isShowCellMenu) {
                hideCellMenu()
            }
            if (this.sheetOverlays.isShowGroupMenu) {
                hideGroupMenu()
            }
            if (this.sheetOverlays.isShowColumnMenu) {
                hideColumnMenu()
            }
            if (this.reservationSelection.isTimeSelectMode) {
                return
            }
            this.selectedAreaHelper.clearSelectedRange()
            this.sheetOverlays.reservationMenuPosition = this.getMousePosition(e)
            setSelectedReservation(deepCopy(this.reservation))
            this.reservationSelection.selectedHService = deepCopy(this.reservation.hserviceID)
            showReservationMenu()
        },

        // MARK: -
        updateElement() {
            this.$nextTick(() => {
                let el = this.$refs.rsvCell
                if (el != undefined) {
                    this.reservationSelection.selectedReservationElement = el
                }
            })
        },
        checkReservationDataIncluded(key) {
            return this.sheetState.reservationSetting.cellInfo?.includes(key) ?? false
        },
        getCalcBgColorValueForCSS() {
            return `background: ${ this.palette[this.reservation.statusID.paletteIndex] };`
        },
        getCalcLeftValueForCSS() {
            if (this.reservation.x != 0) {
                let whiteSpace = 20 / this.maxDepth
                let position = this.reservation.x
                let rightMargin = whiteSpace * position
                let left = Math.floor(this.reservation.left * 10000) / 10000
                return `left: calc(${ left }% - ${ rightMargin }px);`
            }
            return ''
        },
        getCalcWidthValueForCSS() {
            let whiteSpace = (20 / (100 / this.reservation.width)).toFixed()
            let width = Math.floor(this.reservation.width * 10000) / 10000
            return `width: calc(${ width }% - ${ whiteSpace }px);`
        },
        getCalcTopAndHeightValueForCSS() {
            try {
                let getIndexAndPos = (y, isStart) => {
                    let time;
                    let decimalPart;
                    let index = Math.trunc(y / this.timeInterval)
                    if (index >= this.timeArray.length) {
                        if (isStart) {
                            throw Error('The reservation does not overlap with the operating hours.')
                        } else {
                            time = this.timeArray[this.timeArray.length - 1]
                            decimalPart = 1
                        }
                    } else {
                        time = this.timeArray[index]
                        decimalPart = (y / this.timeInterval) % 1
                    }
                    return time.topMargin + (time.height * decimalPart)
                }

                let top = getIndexAndPos(this.reservation.startY, true)
                let bottom = getIndexAndPos(this.reservation.endY + 1, false)

                return `top: calc(${ top }px); height: ${ bottom - top }px;`
            } catch (err) {
                console.log(err)
                return 'display: none;'
            }
        },
        getMousePosition(e) {
            let sheetRect = this.sheetState.sheetElement.getBoundingClientRect()
            let scrollRect = this.sheetState.sheetScrollElement
            let x = e.clientX - sheetRect.x + scrollRect.scrollLeft
            let y = e.clientY - sheetRect.y + scrollRect.scrollTop
            return { x: x, y: y }
        },

        // MARK: - Network
        action_ReservationMouseOver(event) {
            this.hoverEvent.x = event.clientX
            this.hoverEvent.y = event.clientY

            const newReservation = deepCopy(this.reservation)
            newReservation.userTreatmentMemo = this.treatmentMemo

            this.$emit('action_ReservationMouseOver', newReservation, this.hoverEvent, true)
        },
        action_ReservationMouseOut(event) {
            const rect = this.$el.getBoundingClientRect()
            const isInRsvItem = (
                event.clientX >= rect.left &&
                event.clientX <= rect.right &&
                event.clientY >= rect.top &&
                event.clientY <= rect.bottom
            )
            let reservation = isInRsvItem ? this.reservation : undefined
            this.$emit('action_ReservationMouseOver', reservation, {}, false)
        }
    }
}
</script>
<style scoped>
.name_box {
    display: flex;
    align-items: center;
    gap: 0 2px;
}
</style>